import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
	GET_REGISTRATION_LINK_STATUS_CALL,
	GET_REGISTRATION_LINK_STATUS_DONE,
	GET_REGISTRATION_LINK_STATUS_FAIL,
	RESET_REGISTRATION_LINK_STATUS,
	POST_CREATE_REGISTRATION_EMAIL_USER_CALL,
	POST_CREATE_REGISTRATION_EMAIL_USER_DONE,
	POST_CREATE_REGISTRATION_EMAIL_USER_FAIL,
	POST_CREATE_REGISTRATION_MOBILE_USER_CALL,
	POST_CREATE_REGISTRATION_MOBILE_USER_DONE,
	POST_CREATE_REGISTRATION_MOBILE_USER_FAIL,
	POST_REGISTER_REGISTRATION_LINK_USER_CALL,
	POST_REGISTER_REGISTRATION_LINK_USER_DONE,
	POST_REGISTER_REGISTRATION_LINK_USER_FAIL,
} from '@src/store/types';

const defaultSideEffectState = {
	isLoading: false,
	isLoaded: false,
	error: null,
};

const initialState = {
	linkStatus: {},
	getLinkStatusSideEffect: defaultSideEffectState,
	createEmailUserSideEffect: defaultSideEffectState,
	createMobileUserSideEffect: defaultSideEffectState,
	registerUserSideEffect: defaultSideEffectState,
};

export default handleActions({
	[GET_REGISTRATION_LINK_STATUS_CALL](state) {
		return update(state, {
			getLinkStatusSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_REGISTRATION_LINK_STATUS_DONE](state, { payload: { res } }) {
		return update(state, {
			linkStatus: { $set: res },
			getLinkStatusSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_REGISTRATION_LINK_STATUS_FAIL](state, { payload }) {
		return update(state, {
			getLinkStatusSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[POST_CREATE_REGISTRATION_EMAIL_USER_CALL](state) {
		return update(state, {
			createEmailUserSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[POST_CREATE_REGISTRATION_EMAIL_USER_DONE](state) {
		return update(state, {
			createEmailUserSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[POST_CREATE_REGISTRATION_EMAIL_USER_FAIL](state, { payload }) {
		return update(state, {
			createEmailUserSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload?.error || payload,
			} },
		});
	},
	[POST_CREATE_REGISTRATION_MOBILE_USER_CALL](state) {
		return update(state, {
			createMobileUserSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[POST_CREATE_REGISTRATION_MOBILE_USER_DONE](state) {
		return update(state, {
			createMobileUserSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[POST_CREATE_REGISTRATION_MOBILE_USER_FAIL](state, { payload }) {
		return update(state, {
			createMobileUserSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload?.error || payload,
			} },
		});
	},
	[POST_REGISTER_REGISTRATION_LINK_USER_CALL](state) {
		return update(state, {
			registerUserSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[POST_REGISTER_REGISTRATION_LINK_USER_DONE](state) {
		return update(state, {
			registerUserSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[POST_REGISTER_REGISTRATION_LINK_USER_FAIL](state, { payload }) {
		return update(state, {
			registerUserSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload?.error || payload,
			} },
		});
	},
	[RESET_REGISTRATION_LINK_STATUS]() {
		return initialState;
	},
}, initialState);
